import { z } from 'zod';
import { SafeStringSchema } from '../types/CommonSchemas';

export const UserSchema = z.object({
    login: SafeStringSchema,
    droneImei: SafeStringSchema,
    isAdmin: z.boolean(),
    isConfirm: z.boolean(),
    // not in api
    missionPlannerUrl: SafeStringSchema
});

export type UserData = z.infer<typeof UserSchema>;

export interface UserLoginRequestData {
    username: string;
    password: string;
}

export interface UserRegisterRequestData {
    email: string;
    password: string;
}
